import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { API_CONSTANTS } from '../constants';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(
    private http: HttpClientService
  ) { }

  getSystemModules(query?: any) {
    return this.http.get(API_CONSTANTS.LOOKUP + '/system-modules', query)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getLogTypes(query?: any) {
    return this.http.get(API_CONSTANTS.LOOKUP + '/log-types', query)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
